export default {
      id: "rollback-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#rollback",
      toString: function () {
        return this.url;
      }
    }